
import './App.css';
import { router } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { useEffect } from 'react';
import { applySEO, applyThemeAndFooterColors } from './utils/seoHelper';
import baseURL from './Components/url';
import InstallPwaModal from './Components/InstallPwaModal/InstallPwaModal';


function App() {
    useEffect(() => {
        // 1. Aplicar colores cacheados en localStorage inmediatamente para evitar saltos
        const cachedThemeColor = localStorage.getItem('site_theme_color');
        const cachedFooterColor = localStorage.getItem('site_footer_color');
        const cachedHoverColor = localStorage.getItem('site_hover_color');
        if (cachedThemeColor || cachedFooterColor || cachedHoverColor) {
            applyThemeAndFooterColors(cachedThemeColor, cachedFooterColor || cachedThemeColor, cachedHoverColor || '#eb244b');
        }

        // 2. Cargar configuración SEO y colores globales desde el backend
        const fetchGlobalSEO = async () => {
            try {
                const res = await fetch(`${baseURL}/configuracionSeoApi.php?action=get_seo`);
                if (res.ok) {
                    const data = await res.json();
                    if (data && data.status === 'success' && data.data) {
                        const s = data.data;
                        applySEO({
                            title: s.meta_title,
                            description: s.meta_description,
                            keywords: s.meta_keywords,
                            canonical: s.canonical_url,
                            robots: s.robots_directive,
                            ogTitle: s.og_title,
                            ogDescription: s.og_description,
                            ogImage: s.og_image,
                            ogType: s.og_type,
                            twitterCard: s.twitter_card,
                            twitterSite: s.twitter_site,
                            themeColor: s.theme_color,
                            footerColor: s.footer_color || s.theme_color,
                            hoverColor: s.hover_color || '#eb244b',
                            author: s.author
                        });
                    }
                }
            } catch (err) {
                console.error('Error al cargar configuración global SEO/Tema:', err);
            }
        };

        fetchGlobalSEO();

        // 3. Escuchar evento en tiempo real cuando se guarda en el dashboard
        const handleSeoUpdated = (e) => {
            if (e.detail) {
                applyThemeAndFooterColors(
                    e.detail.theme_color,
                    e.detail.footer_color || e.detail.theme_color,
                    e.detail.hover_color || '#eb244b'
                );
            } else {
                fetchGlobalSEO();
            }
        };

        window.addEventListener('seo-updated', handleSeoUpdated);
        return () => {
            window.removeEventListener('seo-updated', handleSeoUpdated);
        };
    }, []);

    return (
        <>
            <RouterProvider router={router} />
            <InstallPwaModal />
        </>
    );
}

export default App;
